var _circle, _rect, _path, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 12,
    cy: 12.0004,
    r: 10.5,
    fill: "#30C6E2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.96249,
    y: 6.75037,
    width: 1.575,
    height: 10.5,
    rx: 0.7875,
    fill: "#30C6E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01251 12.7878C6.57759 12.7878 6.22501 12.4353 6.22501 12.0003C6.22501 11.5654 6.57759 11.2128 7.01251 11.2128H16.9875C17.4224 11.2128 17.775 11.5654 17.775 12.0003C17.775 12.4353 17.4224 12.7878 16.9875 12.7878H7.01251Z",
    fill: "#30C6E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2125,
    y: 6.75037,
    width: 1.575,
    height: 10.5,
    rx: 0.7875,
    fill: "#30C6E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4625,
    y: 6.75037,
    width: 1.575,
    height: 6.0375,
    rx: 0.7875,
    fill: "#30C6E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.ad8ac69f5ce37bdb2666181158fb91ca.svg";
export { ForwardRef as ReactComponent };